import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useState } from "react";

interface CommentFormProps {
  onSuccess: (comment: string, time: string) => void;
  onCancel: () => void;
  buttonLabel?: string;
  hasDate?: boolean;
}

export function CommentForm({
  onSuccess,
  onCancel,
  buttonLabel = "Submit",
  hasDate = false,
}: CommentFormProps) {
  const [comment, setComment] = useState("");
  const [time, setTime] = useState("");

  const handleSubmit = () => {
    if (!time) {
      onSuccess(comment, "");
      return;
    }

    const today = new Date();
    const [hours, minutes] = time.split(":");
    today.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
    onSuccess(comment, today.toISOString());
  };

  return (
    <div className="mt-2 space-y-2">
      <Textarea
        placeholder="Comment (optional)"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        className="bg-slate-700 text-white border-slate-600 min-h-[64px] max-h-96 resize-y"
        rows={3}
      />
      {hasDate && (
        <div className="flex items-center space-x-2">
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className="bg-slate-800 text-slate-100 border-slate-700 rounded-md px-3 py-2 [color-scheme:dark]"
          />
          <span className="text-sm text-slate-400">Schedule Time</span>
        </div>
      )}
      <div className="flex justify-between items-center">
        <Button onClick={handleSubmit}>{buttonLabel}</Button>
        <button
          onClick={onCancel}
          className="text-sm text-slate-400 hover:text-slate-300"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export const formatInterval = (index: number) => {
  // Calculate hours and minutes
  const totalMinutes = index * 10;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Format with leading zeros
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
};
